<template>
  <div>
    <el-container>
      <!-------头部部分开始-------------->
      <el-header>
        <div class="left">
          <div class="title_log">
            <a :href="config.exhibitionList" target="_blank" > <img alt="" src="../static/title_logo.png" /></a>
              
          </div>
          <div class="img"><img alt="" src="../static/logo.png" /></div>
          <div class="txt">
            <p class="p1">{{ $t('header.title') }}</p>
            <p class="p2">{{ $t('header.theme') }}</p>
            <p class="p3">{{ $t('header.time') }}</p> 
          </div>
        </div>

        <div class="portrait">
          <div class="enlish">
            <div class="language" @click="changeLang()">
              <div v-if="lang == 'en'" class="chese">
              
              {{ $t('login.zh') }}</div>
              <div v-else class="english">
               
                {{ $t('login.en') }}</div>
            </div>
          </div>

          <el-col :span="25" style="width:210px"
            ><span @click="outForm()" style=" cursor: pointer; color: #FFFFFF;">
              <i class="el-icon-switch-button" style="margin-right: 11px"></i>
              {{ $t('logout.cancellation') }}</span
            ><span>
            </span>
          </el-col>
        </div>
      </el-header>
      <!----------------------el-header结束---------------------------->
      <div>
        <el-dialog :visible.sync="dialogVisible" :title="$t('logout.tip')" width="20%">
          <span>{{ $t('logout.sureTip') }}</span>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="sure()">{{ $t('logout.sure') }}</el-button>
            <el-button size="small" @click="dialogVisible = false">{{ $t('logout.cancel') }}</el-button>
          </span>
        </el-dialog>
      </div>

      <!--------------------------------------------左侧栏部分开始------------------------------------------>
      <div class="container">
        <el-container>
          <el-row v-show="open" class="tac">
            <transition name="el-fade-in-linear">
              <el-col class="aisd">
                <el-menu
                  :default-active="defaultActive"
                  class="el-menu-vertical-demo"
                  active-text-color="#006fb8"
                  text-color="#666666"
                  ref="menu"
                  :default-openeds="['1']"
                >
                  <el-submenu index="1">
                    <template
                      ><span slot="title" class="link">{{ $t('sidebar.projectName') }}</span></template
                    >
                    <router-link to="homeIndex">
                      <el-menu-item index="/backIndex/homeIndex">
                        <img v-if="$route.path == '/backIndex/homeIndex'" class="icon" src="../static/menuIcon/首页-选中.png" />
                        <img v-else class="icon" src="../static/menuIcon/首页-未选中.png" />{{ $t('sidebar.home') }}
                      </el-menu-item>
                    </router-link>


                    <router-link to="personInfo">
                      <el-menu-item index="/backIndex/personInfo">
                        <img v-if="$route.path == '/backIndex/personInfo'" class="icon" src="../static/menuIcon/个人信息_选中.png" />
                        <img v-else class="icon" src="../static/menuIcon/个人信息_未选中.png" />
                        {{ $t('sidebar.baseInfo') }}</el-menu-item
                      >
                    </router-link>

                    <!-- <router-link to="group">
                      <el-menu-item index="/backIndex/group">
                        <img v-if="$route.path == '/backIndex/group'" class="icon" src="../static/menuIcon/team.png" />
                        <img v-else class="icon" src="../static/menuIcon/team_no.png" />
                        {{ $t('person.tabs.tab4') }}</el-menu-item
                      >
                    </router-link> -->
                    <!-- <router-link to=""> -->
                      <el-menu-item @click="goHomepage" class="goOnline">
                        <img v-if="goFlag == true" class="icon" src="../static/menuIcon/线上展会_选中.png" />
                        <img v-else class="icon" src="../static/menuIcon/线上展会_未选中.png" />
                        {{ $t('sidebar.xianshang') }}</el-menu-item>
                    <!-- </router-link> -->
                    <router-link to="recommendInfo">
                      <el-menu-item index="/backIndex/recommendInfo">
                        <img v-if="$route.path == '/backIndex/recommendInfo'" class="icon" src="../static/menuIcon/为我推荐_选中.png" />
                        <img v-else class="icon" src="../static/menuIcon/为我推荐_未选中.png" />
                        {{ $t('sidebar.recommend') }}</el-menu-item
                      >
                    </router-link>
                    <router-link to="collectionInfo">
                      <el-menu-item index="/backIndex/collectionInfo">
                        <img v-if="$route.path == '/backIndex/collectionInfo'" class="icon" src="../static/menuIcon/我的收藏_选中.png" />
                        <img v-else class="icon" src="../static/menuIcon/我的收藏_未选中.png" />
                        {{ $t('sidebar.collected') }}</el-menu-item
                      >
                    </router-link>
                    <router-link to="myMessage">
                      <el-menu-item index="/backIndex/myMessage" class="dotPosition">
                        <img
                          v-if="$route.path == '/backIndex/myMessage' || $route.path == '/backIndex/messageDetail'"
                          class="icon"
                          src="../static/menuIcon/我的消息_选中.png"
                        />
                        <img v-else class="icon" src="../static/menuIcon/我的消息_未选中.png" /> {{ $t('sidebar.message') }}
                        <el-badge :is-dot="num"></el-badge>
                      </el-menu-item>
                    </router-link>
                  </el-submenu>
                </el-menu>
              </el-col>
            </transition>
          </el-row>
          <!-------左侧栏部分结束-------------->

          <!-------右侧部分开始-------------->
          <el-main class="elmain" style="overflow-y: hidden">
              <router-view @getMessage="showMsg" />
          </el-main>
          <!-------右侧部分结束-------------->
        </el-container>
      </div>
    </el-container>
  </div>
</template>

<script>
import { logout } from '../../api/login.js';
import { backFront } from '../../utils/common.js';
import { getLists } from '../../api/message.js';  //接口刷新数据

import configuration from "../../config.js";


export default {
  data() {
    return {
      backFront: backFront(),
      open: true,
      dialogVisible: false,
      fullscreen: false,
      defaultActive: '',
      num: false,
      lang: '',
      goFlag: false,
      config:configuration,
    };
  },
  methods: {
  

    goHomepage() {
      this.goFlag = true
      window.open(backFront());
    },
    changeLang() {
      if (this.lang == 'zh') {
        localStorage.setItem('lang', 'en');
        this.$i18n.locale = 'en';
        this.lang = 'en';
      } else if (this.lang == 'en') {
        localStorage.setItem('lang', 'zh');
        this.$i18n.locale = 'zh';
        this.lang = 'zh';
      }
      window.location.reload();
    },
    showMsg(val) {
      // methods方法  val即为子组件传过来的值
      this.num = val;
    },
    stateSwitch() {
      this.open = !this.open;
    },

    sure() {
      sessionStorage.clear();
      this.dialogVisible = !this.dialogVisible;
      // this.$router.replace('/adminLogin');
      window.location.href = this.backFront + '?viewFlag';
      localStorage.removeItem('lang')
    },
    async logout() {
      try {
        const { data } = await logout();
        if (data.code == 200) {
          this.dialogVisible = true;
        } else {
          this.$message.error(this.$t('sidebar.error'));
        }
      } catch (error) {
        console.log(error);
      }
    },

    outForm() {
         this.logout();
       
    },

    //获取
    async getList() {
      try {
        const { data } = await getLists();
        if (data.code === 200) {
          let count = this.unread(data.data);
          if (count > 0) {
                this.num  = true;
          } else {
              this.num  = false;
          }
        }
      } catch (err) {
           console.log(err.msg);
      }
    },

    //记录未读消息数量
     unread(arr) {
      let count = 0;
      arr.forEach((item, index) => {
        if (item.count != 0) {
          count += 1;
        }
      });
      return count;
     },

},




  created() {
    this.getList(); //函数调用
     
    const lang = localStorage.getItem('lang');
    this.$i18n.locale = lang ? lang : 'zh';
    this.lang = lang ? lang : 'zh';
    let i = this.$route.path;
    if (i == '/backIndex/messageDetail') {
      i = '/backIndex/myMessage';
    }
    this.defaultActive = i;
  },
  watch: {
    $route() {
      let i = this.$route.path;
      if (i == '/backIndex/messageDetail') {
        i = '/backIndex/myMessage';
      }
      localStorage.setItem('index', i); //刷新
      setTimeout(() => {
        //路由跳转
        this.$refs.menu.activeIndex = i;
      }, 100);
    },
    goFlag(newVal,oldVal){
      if(newVal == true ){
        this.goFlag = false
      }
    }
  },
};
</script>
<style scoped>
* {
  margin: 0px;
  padding: 0px;
  text-decoration: none;
}

body,
html {
  height: 100%;
  width: 100%;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-image: url('../static/backImg.png');
  width: 100%;
  box-sizing: border-box;
  padding-right: 20px;
  height: 74px !important;
}

.title_log img {
  height: 62px;
}

.link {
  font-size: 18px;
  font-weight: 500;
  color: #006fb8;
}

.img img {
  height: 62px;
  margin: 0 10px 0 20px;
}

.icon {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}

.el-menu {
  border: none;
}

.el-menu-item {
  display: flex;
  align-items: center;
}

.el-menu-item:hover {
  background: #e8f6ff;
}

.el-menu-item.is-active {
  background: #e8f6ff !important;
}

.el-main {
  background-color: #f0f2f5;
  color: #333;
  padding: 20px 20px !important;
}

.el-row >>> .el-col-24 {
  width: 220px;
  background: white !important;

  /* background-color: white; */
}

.left {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  margin-left: 50px;
  color: white;
}

.el-header .title {
  font-size: 21px;
  margin-left: 30px;
}

.right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 25px;
  margin-right: 50px;
  color: white;
}

.icon1 i {
  margin-right: 30px;
}

.portrait {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.portrait img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 30px;
}

.el-dropdown {
  position: relative;
  top: -2px;
}

.el-dropdown-link {
  cursor: pointer;
  color: white;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
.goOnline{
  background:  #fff !important;
}
</style>
<style lang="scss" scoped>
.language {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  margin-left: 5px;

  .chese {
    margin-left: 9px;
    margin-right: 5px;
    padding-right: 5px;
    white-space: nowrap;
    cursor: pointer;
    img {
      vertical-align: middle;
      margin-right: 6px;
      width: 24px;
      height: 24px;
    }
  }

  .english {
    margin-left: 9px;
    margin-right: 5px;
    padding-right: 5px;
    white-space: nowrap;
    cursor: pointer;
    img {
      vertical-align: middle;
      margin-right: 6px;
      width: 24px;
      height: 24px;
    }
  }
}
</style>
<style scoped>
.el-menu-item >>> .el-badge__content.is-fixed.is-dot {
  right: -7px;
}

.el-menu-item >>> .el-menu-item * {
  vertical-align: top;
}

.el-menu-item >>> .el-badge {
  display: block !important;
}
</style>
<style scoped>
.dialog-footer >>> .el-button--small,
.el-button--small.is-round {
  padding: 9px 15px !important;
  box-sizing: border-box;
}
</style>
